<template>
  <div class="row form-group" v-bind:class="{ 'form-group--error': haserror }">
    <div :id="'rowanker' + rowindex"></div>
    <div :class="'leftcolumn column col-md-' + colsize[0]">
      <span class="pull-right helptextholder" v-if="showhelptext">
        <div v-if="helpcollapse">
          <i :class="helpicon" :title="helpicontext" class="pointer" @click="collapsehelptext = !collapsehelptext"></i>
        </div>
        <div v-show="!helpcollapse">
          <i :class="helpicon" :title="helpicontext" class="pointer" v-bind:data-xsethelpcontrol="helptext"></i>
        </div>
      </span>
      <label :for="labelfor">
        <span v-html="labeltext"></span>
      </label>
    </div>
    <div :class="'column col-md-' + colsize[1] + ' col-xs-' + (colsize[1] + colsize[0])">
      <slot></slot>
      <slot name="errormessages"></slot>
    </div>
    <div :class="'column col-md-' + colsize[2] + ' col-xs-' + colsize[2]" v-if="colsize.length > 2">
      <slot name="col3"></slot>
    </div>
    <fadetrans :duration="{ enter: 300, leave: 200 }">
      <div
        :class="'column col-md-' + (colsize[1] + colsize[0]) + ' col-xs-' + (colsize[1] + colsize[0])"
        v-if="collapsehelptext"
      >
        <div class="infohelpcollapse row">
          <div class="col-md-1">
            <i :class="helpicon + ' fa-2x'" aria-hidden="true"></i>
          </div>
          <div class="col-md-11 infohelpcollapsetext">
            <span v-html="helptext"></span>
          </div>
        </div>
      </div>
    </fadetrans>
  </div>
</template>
<script>
import { FadeTransition as fadetrans } from 'vue2-transitions'
export default {
  name: 'brow',
  props: {
    labeltext: {
      type: String,
      default: '',
    },
    labelfor: {
      type: String,
      default: '',
    },
    helptext: {
      type: String,
      default: '',
    },
    colsize: {
      type: Array,
      default() {
        return [4, 8]
      },
    },
    haserror: {
      type: Boolean,
      default: false,
    },
    helpicon: {
      type: String,
      default: 'fa fa-question-circle-o',
    },
    helpcollapse: {
      type: Boolean,
      default: false,
    },
    helpicontext: {
      type: String,
      default: 'info',
    },
    rowindex: {
      type: String,
    },
  },
  data: function () {
    return {
      showhelptext: false,
      collapsehelptext: false,
    }
  },
  methods: {},
  created() {
    if (this.helptext !== '') {
      this.showhelptext = true
    }
  },
  components: {
    fadetrans,
  },
}
</script>
